(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finacil-catalogo"] && !Shopify.designMode) return;
  try {
    
  /* Si alguien llega a una tarjeta por su ancla (#tu-cfo-externo), la abre. */
  (function () {
    function abrirDestino() {
      if (!location.hash) return;
      var el = document.querySelector(location.hash);
      if (el && el.tagName === 'DETAILS') el.open = true;
    }
    window.addEventListener('hashchange', abrirDestino);
    abrirDestino();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finacil-hero"] && !Shopify.designMode) return;
  try {
    
  class FinacilHero extends HTMLElement {
    connectedCallback() {
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slides = Array.from(this.querySelectorAll('.fn-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.tagEl = this.querySelector('[data-hero-tag]');
      this.titleEl = this.querySelector('[data-hero-title]');
      this.subEl = this.querySelector('[data-hero-sub]');
      this.ctaEl = this.querySelector('[data-hero-cta]');
      this.interval = parseInt(this.dataset.interval, 10) || 6500;
      this.i = 0;
      this.paused = false;

      if (this.slides.length < 2) return;

      this.dots.forEach((d, k) => d.addEventListener('click', () => { this.show(k); this.start(); }));
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.addEventListener('focusin', () => { this.paused = true; });
      this.addEventListener('focusout', () => { this.paused = false; });
      this.onVis = () => { if (document.visibilityState === 'visible') this.start(); };
      document.addEventListener('visibilitychange', this.onVis);

      this.show(0);
      this.start();
    }
    disconnectedCallback() {
      clearInterval(this.loop);
      document.removeEventListener('visibilitychange', this.onVis);
    }
    show(n) {
      this.i = (n + this.slides.length) % this.slides.length;
      this.slides.forEach((s, k) => s.classList.toggle('is-on', k === this.i));
      this.dots.forEach((d, k) => {
        d.classList.toggle('is-on', k === this.i);
        d.setAttribute('aria-selected', k === this.i ? 'true' : 'false');
      });
      const s = this.slides[this.i];
      if (this.tagEl) this.tagEl.textContent = s.dataset.tag || '';
      if (this.titleEl) this.titleEl.textContent = s.dataset.title || '';
      if (this.subEl) {
        const sub = s.dataset.subtitle || '';
        this.subEl.textContent = sub;
        this.subEl.classList.toggle('is-empty', sub === '');
      }
      if (this.ctaEl) {
        this.ctaEl.textContent = s.dataset.cta || '';
        this.ctaEl.setAttribute('href', s.dataset.link || '#');
      }
    }
    start() {
      if (this.reduce) return;
      clearInterval(this.loop);
      this.loop = setInterval(() => {
        if (!this.paused && document.visibilityState === 'visible') this.show(this.i + 1);
      }, this.interval);
    }
  }
  if (!customElements.get('finacil-hero')) customElements.define('finacil-hero', FinacilHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
